// $.products item по требованиям СОПР 1.0 https://cianru.atlassian.net/wiki/spaces/ML/pages/443613219
import { INewbuilding } from '../../../types/newbuilding';
import { IProduct } from '../../../types/analytics';

export function getAnalyticsProductFromNewBuilding(newbuilding: INewbuilding): IProduct {
  const { id, name, builderInfo, region, phone, isReliable, isDealRequestSubstitutionPhone } = newbuilding;

  return {
    id: Number(id),
    offerType: 'JK',
    position: 1,
    extra: {
      name: `ЖК «${name}»`,
      nv: isReliable,
      brand: `${builderInfo ? builderInfo.id : ''}/developer_company`,
      consultant: isDealRequestSubstitutionPhone,
      region: region ? region.replace(/ /g, '-') : undefined,
      offerPhone: phone,
    },
  };
}
